import {Component, HostListener, ChangeDetectorRef} from '@angular/core';

import {GlobalState} from '../../../global.state';
import { Router } from '@angular/router';

@Component({
  selector: 'ba-page-top',
  templateUrl: './baPageTop.html',
  styleUrls: ['./baPageTop.scss']
})
export class BaPageTop {
    topic;
    public isScrolled:boolean = false;
    public isMenuCollapsed:boolean = false;
    public activePageTitle:string = '';
    compareLinks : Object[];
    links: Array<any>;
    public url;
    public compare;
    public compareNum;
    public displayPassage = false;
    allowRedirect: boolean;
    constructor(private _state:GlobalState,private router: Router, ) {

    this.url = this.router.url;
    this.compareNum = this.url.substr(this.url.lastIndexOf('/') + 1);

    this.compareLinks = [
        /* { name: "Compare Torah", id: 1 },
        { name: "Compare New Testament", id: 2 },
        { name: "Compare Quran", id: 3 },
        { name: "Compare Book of Mornom", id: 4 },
        { name: "Compare Old Testament", id: 5 },
        { name: "Compare Modern Prophets", id: 6 }, */
        /* { name: "Compare All Texts (Some Partial or Limited)", id: 3 },
        { name: "Compare New Testament and Quran", id: 2 },
        { name: "Compare New Testament and Another Testament", id: 1 },
        { name: "Compare Old Testament and New Testament", id: 4 },
        { name: "Compare Old Testament, New Testament, and Another Testament", id: 5 },
        { name: "Compare The Prophets, Ancient and The Prophets, Modern", id: 7 },
        { name: "Compare Upanishads (Limited) and Sutra Pitaka (Limited)", id: 6 } */
        { id: 1, name: 'Book of Mormon - Modern Prophets' },
        { id: 2, name: 'Book of Mormon - New Testament' },
        { id: 3, name: 'Book of Mormon - Old Testament' },
        { id: 4, name: 'Book of Mormon - Quran' },
        { id: 5, name: 'Book of Mormon - Torah' },
        { id: 6, name: 'Modern Prophets - Book of Mormon' },
        { id: 7, name: 'Modern Prophets - New Testament' },
        { id: 8, name: 'Modern Prophets - Old Testament' },
        { id: 9, name: 'Modern Prophets - Quran' },
        { id: 10, name: 'Modern Prophets - Torah' },
        { id: 11, name: 'New Testament - Book of Mormon' },
        { id: 12, name: 'New Testament - Modern Prophets' },
        { id: 13, name: 'New Testament - Old Testament' },
        { id: 14, name: 'New Testament - Quran' },
        { id: 15, name: 'New Testament - Torah' },
        { id: 16, name: 'Old Testament (Ancient Prophets and Writings) - Torah' },
        { id: 17, name: 'Old Testament - Book of Mormon' },
        { id: 18, name: 'Old Testament - Modern Prophets' },
        { id: 19, name: 'Old Testament - New Testament' },
        { id: 20, name: 'Old Testament - Quran' },
        { id: 21, name: 'Quran - Book of Mormon' },
        { id: 22, name: 'Quran - Modern Prophets' },
        { id: 23, name: 'Quran - New Testament' },
        { id: 24, name: 'Quran - Old Testament' },
        { id: 25, name: 'Quran - Torah' },
        { id: 26, name: 'Torah - Book of Mormon' },
        { id: 27, name: 'Torah - Modern Prophets' },
        { id: 28, name: 'Torah - New Testament' },
        { id: 29, name: 'Torah - Quran' },
        { id: 30, name: 'Torah - Old Testament (Ancient Prophets and Writings)' }
    ];
    this.setTitle(false); 

    this.btnActivate(1);

    this.topic = localStorage.getItem('topic');
        this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
        this.isMenuCollapsed = isCollapsed;
        });
        this._state.subscribe('menu.activeLink', (activeLink) => {
        if (activeLink) {
            this.activePageTitle = activeLink.title;
        }
        });  
    }
    topicLocalStorage(){
        this.topic = localStorage.getItem('topic');
    }
    logout(){
        localStorage.removeItem('currentUser');
        localStorage.clear(); 
    //localStorage.removeItem;
        localStorage.setItem('reload','Y');
        this.router.navigate(['login']);
        //window.location.href="#login";
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(e) {
        //
        if (window.pageYOffset > 80) {
        let element = document.getElementById('navbar');
        element.classList.add('sticky');
        } else {
        let element = document.getElementById('navbar');
        element.classList.remove('sticky'); 
        }
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        location.reload();
    }


    public toggleMenu() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
        this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
        return false;
    }

    public scrolledChanged(isScrolled) {
        this.isScrolled = isScrolled;
    }

    viewLocation;
    public isActive() {
        //var active = (this.viewLocation === $location.path());
        return this.active;
        //this.function();
    };
    active
    public function(id){
    this.active =id;
    // return active;
    }


    selectedId:number; 
    btnActivate(Id : number) {
    this.selectedId= Id; 
    }
    getTextColor(Id:number){
    // if(Id == 5 && this.selectedId == 5){
    //   if(document.getElementById("registration")!=null && document.getElementById("registration")!= undefined){
    //     document.getElementById("registration").style.color = "#ED3237";
    //   }
    // }
    // if(Id != 5 && this.selectedId != 5){
    //   if(document.getElementById("registration")!=null && document.getElementById("registration")!= undefined){
    //     document.getElementById("registration").style.color = "black";  
    //   }
    // }
    return (this.selectedId == Id? "active" : "") ;   
    }

    goBackToTopics(){
    this.router.navigate(['pages/masters/discover/']);
    }

    goBackToBelief(){
    
    this.router.navigate(['pages/masters/beliefDiscover/'+localStorage.getItem("prevID")]);
    }

    updateProfile(){
    this.router.navigateByUrl('/pages/masters/updateProfile');
    }
    reducePadding(){
    
    // (<HTMLInputElement> document.getElementById('header_two')).className="stage_top_other";
    //(<HTMLInputElement> document.getElementById('header_two')).style.padding = "0px !important";
    //(<HTMLInputElement> document.getElementById('header_two')).style.background = "red !important";
    (<HTMLInputElement> document.getElementById('header_two')).classList.add("stage_top_other");

    
    }

    padd(flag){
    (<HTMLInputElement> document.getElementById('header_two')).classList.remove("stage_top_other");
    this.setTitle(flag); 
    
    // (<HTMLInputElement> document.getElementById('header_two')).className="stage_top";
    // (<HTMLInputElement> document.getElementById('header_two')).classList.remove("stage_top_other");
    // element.classList.remove("mystyle")
    }
    
        setTitle(flag) {
            if (flag) {
                this.compare = "Compare";
            } else {
                for (let i in this.compareLinks) {
                    if (this.compareLinks[i]['id'] == this.compareNum) {
                        this.compare = this.compareLinks[i]['name'];
                    }
                }
                this.compare = this.compare ? this.compare : "Compare";
            }

            if (this.compare == "Compare") {
                this.displayPassage = false;
            } else {
                this.displayPassage = true;
            }
        }

        /*ngOnInit() {
            var baseFullPath = window.location.href;
            var baseUrlArr = baseFullPath.split("/#");

            var baseUrl = window.location.origin;
            if (baseUrlArr.hasOwnProperty(0)) {
            baseUrl = baseUrlArr[0];
            }

            $("#home-page-logo-link").attr("href", baseUrl)
        }*/
    
        /* getToDonation() {
        this.router.navigate(['pages/masters/donation']);
        } */

}



// WEBPACK FOOTER //
// ./src/app/theme/components/baPageTop/baPageTop.component.ts